
import { Lead } from '@/types/lead';
import { supabase } from '@/integrations/supabase/client';
import { mapDbLeadToLead } from '../mappers/leadMapper';
import { getLeadImages } from '@/services/leadImagesService';
import { getKeyContacts } from '../keyContactService';
import { getLeadsQuery } from './shared/getLeadsQuery';

export const getLeads = async (companyId?: string): Promise<Lead[]> => {
  try {
    // If no company ID provided, return empty array
    if (!companyId) {
      console.warn('No company ID provided to getLeads');
      return [];
    }

    // Use the company ID to filter leads
    const { data, error } = await getLeadsQuery(companyId)
      .order('created_at', { ascending: false });

    if (error) {
      console.error('Error fetching leads:', error);
      throw error;
    }

    // Convert the database leads to the application Lead type
    const leads = data.map((lead) => {
      const leadObj = mapDbLeadToLead(lead);
      return {
        ...leadObj,
        images: (lead.lead_images || []).map((img: any) => ({
          id: img.id,
          leadId: lead.id,
          imageUrl: img.image_url,
          isPrimary: img.is_primary,
          position: img.position,
          createdAt: img.created_at
        })),
        keyContacts: (lead.lead_key_contacts || []).map((contact: any) => ({
          id: contact.id,
          leadId: lead.id,
          name: contact.name,
          email: contact.email,
          phone: contact.phone,
          position: contact.position,
          isPrimary: contact.is_primary,
          notes: contact.notes,
          createdAt: contact.created_at,
          createdBy: contact.created_by,
          linkedinUrl: contact.linkedin_url || undefined,
          source: contact.source || 'manual',
          status: contact.status || 'active'
        }))
      };
    });

    return leads;
  } catch (error) {
    console.error('Error in getLeads:', error);
    return [];
  }
};
